import React, { useState } from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';

interface DescriptionDisplayProps {
    description: string;
    appName: string;
}

const TooltipDescription: React.FC<{ description: string }> = ({ description }) => (
    <OverlayTrigger
        placement="top"
        overlay={
            <Tooltip id={`tooltip-desc`}>
                {description}
            </Tooltip>
        }
    >
        <p className="card-text text-muted small mb-3 card-description">
            {description}
        </p>
    </OverlayTrigger>
);

const ExpandableDescription: React.FC<{ description: string }> = ({ description }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className="description-container">
            <div className={`description-content ${isExpanded ? 'expanded' : ''}`}>
                <p className="card-text text-muted small mb-1">
                    {description}
                </p>
            </div>
            <button
                className="btn btn-link btn-sm p-0 text-muted expand-button"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                {isExpanded ? 'Show less' : 'Show more'}
            </button>
        </div>
    );
};

const ModalDescription: React.FC<{ description: string; appName: string }> = ({ description, appName }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div className="description-container">
                <p
                    className="card-text text-muted small mb-1 card-description"
                    onClick={() => setShowModal(true)}
                    style={{ cursor: 'pointer' }}
                >
                    {description}
                </p>
                <button
                    className="btn btn-link btn-sm p-0 text-muted"
                    onClick={() => setShowModal(true)}
                >
                    Show more
                </button>
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{appName} - Description</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {description}
                </Modal.Body>
            </Modal>
        </>
    );
};

const DescriptionDisplay: React.FC<DescriptionDisplayProps> = ({ description, appName }) => {
    const isVeryLong = description.length > 500;
    const isLong = description.length > 200;

    if (isVeryLong) {
        return <ModalDescription description={description} appName={appName} />;
    }

    if (isLong) {
        return <ExpandableDescription description={description} />;
    }

    return <TooltipDescription description={description} />;
};

export default DescriptionDisplay;